module.exports = __webpack_public_path__ + "static/img/common_location.9308b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/param/common_location.png
// module id = PcGG
// module chunks = 0